module.exports = __webpack_public_path__ + "static/media/arrow-d.fc9f467e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Img/icon/arrow-d.svg
// module id = 96
// module chunks = 0